export const infoList = [
  {
    label: '物流信息',
    value: 'logisticsCompanyName'
  },
  {
    label: '快递单号',
    value: 'deliveryId'
  },
  {
    label: '订单编号',
    value: 'orderSn'
  }
]
